import { gql } from "@apollo/client";

export const GENERATE_TRANSACTION_RECEIPT = gql`
  mutation GenerateTransactionReceipt($transactionId: uuid!) {
    generateTransactionReceipt: generate_transaction_receipt(transaction_id: $transactionId) {
      downloadUrl: download_url
    }
  }
`;

export interface GenerateTransactionReceiptData {
  generateTransactionReceipt: {
    downloadUrl: string;
  };
}

export interface GenerateTransactionReceiptVars {
  transactionId: string;
}
